import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Link, Text } from '@primer/react';
import { Link as GatsbyLink } from 'gatsby';
import { ComponentPageNav } from '~/src/components/component-page-nav';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Box = makeShortcode("Box");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Box style={{
      marginBottom: "24px"
    }} mdxType="Box">
  <ComponentPageNav basePath="/deprecated-components/side-nav" includeReact={true} current="overview" mdxType="ComponentPageNav" />
    </Box>
    <Note variant="warning" mdxType="Note">
  <Text sx={{
        display: 'block',
        fontWeight: 'bold',
        mb: 2
      }} mdxType="Text">Usage of this component is not encouraged</Text>
  <Text mdxType="Text">Please use <Link as={GatsbyLink} to="/components/nav-list" mdxType="Link">nav list</Link> instead.</Text>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      